module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu-sp.2b4f0670.jpg";